import { z } from "zod";
/**
 * Common routePoint schema - shared fields between domain and DTO
 * Contains the core routePoint fields that are common to both representations
 */
export const zRoutePointCommonSchema = z.object({
    id: z.string(),
    idRoute: z.string().nullable(),
    idOrder: z.string().nullable(),
    idBase: z.string().nullable(),
    orderIndex: z.number(),
    // эти поля расчитываюстся при создании, как "идеальные"
    plannedArrivalTime: z.string().nullable(),
    plannedDepartureTime: z.string().nullable(),
    // эти поля указывает техник
    actualArrivalTime: z.string().nullable(),
    actualDepartureTime: z.string().nullable(),
    // эти поля расчитываются при создании, как приближенные к реальности
    expectedArrivalTime: z.string().nullable(),
    expectedDepartureTime: z.string().nullable(),
    // Денормализованные поля из связанного заказа (JOIN при загрузке, только чтение)
    orderNumber: z.string().optional(),
    orderStatus: z.string().optional(),
    // Флаг мягкого удаления (soft-delete) — true если точка отменена (заказ отменён)
    isDeleted: z.boolean().nullish(),
    // Геометрия сегмента маршрута (от этой точки до следующей) — массив [lat, lon] пар
    // Заполняется edge function при withGeometry: true
    segmentGeometry: z.array(z.tuple([z.number(), z.number()])).nullish(),
});
